import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardOut24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconClipboardOut24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.268 4A1.75 1.75 0 0 1 8 2.5h6A1.75 1.75 0 0 1 15.732 4H16a3 3 0 0 1 3 3v3h-1.5V7A1.5 1.5 0 0 0 16 5.5h-.268A1.75 1.75 0 0 1 14 7H8a1.75 1.75 0 0 1-1.732-1.5H6A1.5 1.5 0 0 0 4.5 7v10A1.5 1.5 0 0 0 6 18.5h3V20H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM8 4a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h6a.25.25 0 0 0 .25-.25v-1A.25.25 0 0 0 14 4zm8.939 15.5-6.47-6.47a.75.75 0 1 1 1.061-1.06l6.472 6.472V14.25a.75.75 0 0 1 1.5 0V21h-6.75a.75.75 0 1 1 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardOut24);
